import styled from 'styled-components/macro'

import { Title as TitleBase } from 'components/misc'
import { mq } from 'styles/mq'
import { Thread } from 'styles/misc'
import { TextContainer } from 'components/container'

export const Title = styled(TitleBase)`
  ${mq.smallOnly} {
    margin-top: 6rem;
  }
  ${mq.medium} {
    margin-top: 0;

    &::before {
      ${Thread}
      position: relative;
      width: 100%;
      height: auto;
      aspect-ratio: 2064 / 171;
      clip-path: none;
      mask-image: url("data:image/svg+xml,%3Csvg width='2064' height='171' viewBox='0 0 2064 171' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.26001 62.32C62.66 24.36 134.98 2.88003 207.99 0.600027C238.05 -0.339973 273.25 4.90003 288.04 31.08C301.36 54.67 292.48 86.75 307.83 109.08C325.02 134.1 361.9 133.15 391.65 127.11C459.11 113.41 524.63 87.47 593.43 84.98C691.56 81.43 784.1 125.59 878.31 153.26C972.52 180.94 1138.88 170.28 1134.92 125.34C1134.38 119.19 1125.36 124.88 1123.66 130.82C1119.57 145.1 1125.38 155 1140.7 164.61C1156.02 174.22 1186.52 168.11 1204.5 166.19C1408.05 144.42 1613.57 60.32 1811.23 113.58C1895.09 136.18 1984.61 182.66 2063.28 145.87' stroke='black'  stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
    }
  }
`

export const Figure = styled.figure`
  --description-width: 27rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5rem auto;
  margin: 2rem auto 6rem;
  &.second-flag {
    margin: 2rem auto 10rem;
  }
  max-width: 100%;
  text-align: center;

  ${mq.medium} {
    flex-direction: row;
    justify-content: center;
    text-align: inherit;
    margin: 3rem auto 6rem;
    margin-left: 0;
  }

  ${mq.large} {
    &::before {
      content: '';
      display: block;
      width: var(--description-width);
    }
  }
`

export const Description = styled.figcaption`
  display: none;
  flex-direction: column-reverse;
  align-items: center;
  font-size: 1.2rem;

  span {
    content: '';
    display: block;
    width: 1.6em;
    height: 1.6em;
    margin: 2rem;
    border-radius: 50%;
    flex-shrink: 0;
    opacity: 0.75;
    background-color: var(--theme-color);
  }

  ${mq.medium} {
    display: flex;
    width: var(--description-width);
    flex-shrink: 0;
    flex-direction: row-reverse;
    font-size: 1.4rem;
  }
`

export const Image = styled.img`
  display: block;
  max-width: max-content;
  width: 100%;
`

export const FlagColors = styled(TextContainer)`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  gap: 2rem;
  margin: 5rem auto;

  ${mq.medium} {
    margin: 8rem auto;
    gap: 3rem;
  }

  img {
    display: block;
    margin: 0 auto;
    border-radius: 50%;

    ${mq.smallOnly} {
      max-width: 5rem;
    }
  }

  h3 {
    width: 100%;
    flex-shrink: 0;
    text-align: left;

    ${mq.medium} {
      display: none;
    }
  }

  h4 {
    margin: 1.9rem 0 0;
    font-size: 1.5rem;
    font-weight: 800;

    ${mq.medium} {
      margin: 3rem 0 1.5rem;
      font-size: 2.4rem;
    }
  }

  p {
    font-size: 1.2rem;
    ${mq.smallOnly} {
      line-height: 1.5;
    }
    ${mq.medium} {
      font-size: 1.4rem;
    }
  }

  > div {
    ${mq.ltLarge} {
      flex: 1;
    }

    ${mq.large} {
      width: 8em;
      hyphens: manual;
    }
  }
`

export const ThreadContainer = styled.div`
  position: relative;

  &::before {
    ${Thread}
    left: calc(50% + 25rem);
    top: calc(50% - 50rem);
    right: 0;
    height: 62.9rem;
    mask: url("data:image/svg+xml,%3Csvg width='1766' height='629' viewBox='0 0 1766 629' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.300049 569.92C81.58 629.74 193.92 644.59 287.95 607.93C373.42 574.61 438.35 504.93 509.3 446.78C580.25 388.63 669.68 338.6 759.62 356.64C781.82 361.09 804.64 370.83 816.48 390.13C828.32 409.43 824.01 455.21 802.49 448.16C754.54 432.46 801.56 347.38 839.41 314.02C915.1 247.31 1024.75 242.08 1125.03 230.96C1225.31 219.84 1381.81 201.68 1384.46 100.82C1385.13 75.25 1333.99 82.84 1323.96 106.37C1313.93 129.9 1329 158.31 1351.26 170.91C1373.52 183.51 1400.57 183.8 1426.04 181.44C1524.94 172.27 1617.73 128.39 1700.51 73.49C1728.34 55.03 1757.2 32.57 1765.17 0.130005' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A")
      0% 50% no-repeat;
    mask-size: auto !important;
  }
`
